import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Checkbox } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { AiChipShell, GetAiFilterChipTID } from './AiChipShell';
import { chosenFirst, valueLabelFor } from './AiFilterChip.utils';
export const CheckboxesChip = (param)=>{
    let { testId, fieldLabel, items, selected, operator, searchable = false, isSelectedToBeOnTop = true, showAll = true, valueLabel, tone, onApply, onRemove, biPrefix, autoOpen = false } = param;
    const testIds = useMemo(()=>GetAiFilterChipTID(testId), [
        testId
    ]);
    const { t: commonFilter } = useLocaleKeys('common.filter');
    const isExclude = operator === 'exclude';
    const complementOf = (values)=>items.filter((item)=>!values.includes(item.value)).map((item)=>item.value);
    const passingValues = isExclude ? complementOf(selected) : selected;
    const [query, setQuery] = useState('');
    const [orderedItems, setOrderedItems] = useState(()=>isSelectedToBeOnTop ? chosenFirst(items, passingValues) : items);
    const [draftAll, setDraftAll] = useState(selected.length === 0);
    const [draftValues, setDraftValues] = useState(passingValues);
    const hasValues = selected.length > 0;
    const visibleItems = searchable ? orderedItems.filter((item)=>item.label.toLowerCase().includes(query.trim().toLowerCase())) : orderedItems;
    const resetDraft = ()=>{
        setOrderedItems(isSelectedToBeOnTop ? chosenFirst(items, passingValues) : items);
        setDraftAll(selected.length === 0);
        setDraftValues(passingValues);
        setQuery('');
    };
    const committedSelection = ()=>{
        if (draftAll || draftValues.length === 0) return [];
        return isExclude ? complementOf(draftValues) : draftValues;
    };
    const toggleOption = (value)=>{
        setDraftAll(false);
        setDraftValues((current)=>current.includes(value) ? current.filter((entry)=>entry !== value) : [
                ...current,
                value
            ]);
    };
    const toggleSelectAll = ()=>{
        setDraftAll((current)=>!current);
        setDraftValues([]);
    };
    return /*#__PURE__*/ _jsxs(AiChipShell, {
        testId: testId,
        fieldLabel: fieldLabel,
        biPrefix: biPrefix,
        autoOpen: autoOpen,
        valueLabel: hasValues ? valueLabel !== null && valueLabel !== void 0 ? valueLabel : valueLabelFor(items, passingValues, commonFilter) : commonFilter.chipAll(),
        tone: tone,
        applyText: commonFilter.apply(),
        onOpen: resetDraft,
        onApply: ()=>onApply({
                selected: [
                    ...committedSelection()
                ],
                operator
            }),
        onRemove: onRemove,
        search: searchable ? {
            value: query,
            onChange: setQuery
        } : undefined,
        children: [
            showAll && /*#__PURE__*/ _jsx(Checkbox, {
                testId: testIds.AiFilterChipTestIds.SelectAll(),
                bi: {
                    name: "".concat(biPrefix, "_select_all")
                },
                checked: draftAll,
                onChange: toggleSelectAll,
                label: commonFilter.selectAll()
            }),
            visibleItems.map((item)=>/*#__PURE__*/ _jsx(Checkbox, {
                    testId: testIds.AiFilterChipTestIds.Option(item.value),
                    bi: {
                        name: "".concat(biPrefix, "_option")
                    },
                    checked: !draftAll && draftValues.includes(item.value),
                    onChange: ()=>toggleOption(item.value),
                    label: item.label,
                    disabled: item.disabled
                }, item.value))
        ]
    });
};
